(function () {
  'use strict';
  const CURRENT_YEAR = new Date().getFullYear();

  function parseYearTo(value) {
    if (!value) return CURRENT_YEAR;
    const v = String(value).trim().toLowerCase();
    if (v === 'present' || v === 'current') return CURRENT_YEAR;
    const n = parseInt(v, 10);
    return isNaN(n) ? CURRENT_YEAR : n;
  }

  function parseYearFrom(value) {
    const n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }

  function yearsFromTitle(li) {
    const title = (li.textContent || '').replace(/\s+/g, ' ');
    const m = title.match(/(\d{4})\s*[-–]\s*(\d{4}|Current|Present)/i);
    if (!m) return null;
    return { from: parseInt(m[1], 10), to: parseYearTo(m[2]) };
  }

  function rangeOf(li) {
    const from = parseYearFrom(li.getAttribute('data-year-from'));
    if (from != null) return { from, to: parseYearTo(li.getAttribute('data-year-to')) };
    return yearsFromTitle(li);
  }

  function init(root) {
    const select = root.querySelector('[data-collection-year]');
    const countEl = root.querySelector('[data-collection-year-count]');
    const grid = document.getElementById('product-grid');
    if (!select || !grid) return;
    const items = Array.from(grid.querySelectorAll('li.grid__item'));
    const years = new Set();
    items.forEach((li) => {
      const range = rangeOf(li);
      if (!range) return;
      for (let y = range.from; y <= range.to; y++) years.add(y);
    });
    const sorted = Array.from(years).sort((a, b) => b - a);
    if (!sorted.length) {
      root.hidden = true;
      return;
    }
    sorted.forEach((y) => {
      const opt = document.createElement('option');
      opt.value = String(y);
      opt.textContent = String(y);
      select.appendChild(opt);
    });

    function apply() {
      const year = select.value ? parseInt(select.value, 10) : null;
      let shown = 0;
      items.forEach((li) => {
        const range = rangeOf(li);
        let match = true;
        if (year != null) {
          match = !!range && year >= range.from && year <= range.to;
        }
        li.hidden = !match;
        if (match) shown += 1;
      });
      if (countEl) {
        if (year == null) {
          countEl.hidden = true;
        } else {
          countEl.hidden = false;
          countEl.textContent = shown + (shown === 1 ? ' bar' : ' bars');
        }
      }
    }
    select.addEventListener('change', apply);
  }

  document.querySelectorAll('[data-collection-year-picker]').forEach(init);
})();
